import { render, staticRenderFns } from "./AdminPaymentMethodSettings.vue?vue&type=template&id=3ffe3a84"
import script from "./AdminPaymentMethodSettings.vue?vue&type=script&lang=js"
export * from "./AdminPaymentMethodSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ffe3a84')) {
      api.createRecord('3ffe3a84', component.options)
    } else {
      api.reload('3ffe3a84', component.options)
    }
    module.hot.accept("./AdminPaymentMethodSettings.vue?vue&type=template&id=3ffe3a84", function () {
      api.rerender('3ffe3a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminPaymentMethodSettings.vue"
export default component.exports